import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";
import Permiso from "../../router/Permiso";
import ListadoUsuariosSolicitud from "./ListadoUsuariosSolicitud";

const LowRequestAdmin = ({ token }) => {
  const [searchParams] = useSearchParams();
  const initialTab = searchParams.get('tab') || 'usuarios';
  const [tab, setTab] = useState(initialTab);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const handleRefresh = () => {
    setRefreshTrigger((prev) => prev + 1);
  };


  const renderTab = () => {
    switch (tab) {
      case "usuarios":
       return <ListadoUsuariosSolicitud token={token} onRefresh={handleRefresh} />;
      default:
        return null;
    }
  };

  return (
    <div className="rrhh-admin-outer">
      <div className="rrhh-admin-header">
        <div className="rrhh-admin-header-row">
          <div>
            <div className="usuarios-admin-title">Solicitud de Bajas</div>
            <div className="rrhh-admin-subtitle">
              Gestión para solicitud de bajas
            </div>
          </div>
        </div>
        <div className="usuarios-admin-tabs">
          <Permiso permiso="solicitud_baja_user">
            <button
              className={tab === "usuarios" ? "active" : ""}
              onClick={() => setTab("usuarios")}
            >
              Listado de usuarios
            </button>
          </Permiso>
        </div>
      </div>
      <div className="rrhh-admin-tab-content">
        <div className="reclutamiento-admin-tab-content">{renderTab()}</div>
      </div>
    </div>
  );
};

export default LowRequestAdmin;
